import React from "react";
import Grid from "@mui/material/Grid2";
import { Box } from "@mui/material";

const AgentHeaderImage = ({ headerImage }) => {
  return (
    <Grid container spacing={0} justifyContent="center">
      <Grid item xs={12} display="flex" justifyContent="center">
        <Box
          sx={{
            maxWidth: "800px",
            maxHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          {headerImage && (
            <img
              src={headerImage}
              alt="Agent Header"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default AgentHeaderImage;